import classNames from 'classnames'
import { memo } from 'react'
import { FiShoppingBag } from 'react-icons/fi'
import { useGuests } from '../../../../../hooks/queries/guests/use-guests'
import type { LiveGuest } from '../../../../../types/lives/live'
import { Gifter } from './components/gifter'
import { SelectAll } from './components/select-all'
import { useGetUsersToGift } from './use-get-users-to-gift'

interface Props {
  isPackageSelected: boolean
  handleTogglePackageSelected: () => void
}

export const Gifters = memo(
  ({ isPackageSelected, handleTogglePackageSelected }: Props) => {
    useGuests()

    const {
      checkGifters,
      typeLive,
      handleSelectUserToGift,
      //
    } = useGetUsersToGift()

    const isVideo = !typeLive?.includes('multi')

    return (
      <div className="flex flex-row mb-2 h-10 items-center">
        {!isVideo && (
          <div className="flex flex-row flex-1 gap-2 items-center overflow-y-scroll [&::-webkit-scrollbar]:hidden">
            {checkGifters?.map((gifter) => (
              <Gifter
                key={gifter.userId}
                guest={gifter as LiveGuest}
                handleSelectUserToGift={handleSelectUserToGift}
              />
            ))}
          </div>
        )}

        <div className="flex flex-row items-center gap-1.5">
          <SelectAll />

          <div
            onClick={handleTogglePackageSelected}
            className={classNames(
              'rounded-full w-9 h-9 flex justify-center items-center transition-colors',
              {
                'text-hug-lilac bg-hug-purple/20 ring-2 ring-hug-purple':
                  isPackageSelected,
                'text-white/80 bg-white/10': !isPackageSelected,
              },
            )}
          >
            <FiShoppingBag />
          </div>
        </div>
      </div>
    )
  },
)
